(function () {
    'use strict';

    function platformEntitiesDataService($http) {
        var baseUrl = '[BuildifyApiHost]/api/platformentities/';

        function loadPlatformEntity(id) {
            return $http.get(baseUrl + id.split('/')[1]).then(function (response) {
                return response.data;
            });
        };

        return {
            loadPlatformEntity: loadPlatformEntity
        }
    }

    platformEntitiesDataService.$inject = ['$http'];

    angular.module('ecap.common').service('platformEntitiesDataService', platformEntitiesDataService);
})();
